import React, { useContext, useEffect, useState } from "react";
import useFetch from "../../../../hooks/fetchMSSQL-hook";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { NotificationManager } from "react-notifications";
import { LoaderContext } from "../../../../context/loader-context";
import FormSkel from "../../../../components/Modals/FormSkel";
import axios from "axios";
import { API_URL } from "../../../../config/config";

export default function MachineVI({ machineData }) {
    const [machineProducts, setMachineProducts] = useState(null);
    const [newMachineProducts, setNewMachineProducts] = useState(null);
    const [saveButtonDisabled, setSaveButtonDisabled] = useState(true);
    const [lastVisitId, setLastVisitId] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const loader = useContext(LoaderContext);
    const props = useParams();
    const { fetchMssqlApi } = useFetch();

    useEffect(() => {
        getMachineProducts();
    }, []);

    useEffect(() => {
        isSaveButtonDisabled();
    }, [newMachineProducts]);

    const getMachineProducts = () => {
        fetchMssqlApi(`machine-products?machineId=${props.machineId}`,
            {},
            (products) => {
                products = products.map((item) => ({
                    ...item,
                    Quantity: Number(item.Quantity) || 0,
                }));
                setMachineProducts(products);
                setNewMachineProducts(products);
                loader.showLoader(false);
            }
        );
    };

    const isSaveButtonDisabled = () => {
        if (!newMachineProducts) return;
        let temp = false;
        newMachineProducts.map((i) => {
            if (i?.income !== undefined && i?.income !== null && Number(i?.income) !== 0) {
                temp = true;
                return;
            }
        });
        setSaveButtonDisabled(!temp);
    }

    const [stateEditorOpen, setStateEditorOpen] = useState(false);
    const [editorProduct, setEditorProduct] = useState(null);
    const [editorSelected, setEditorSelected] = useState(0);
    const [stateConfirmMenu, setStateConfirmMenu] = useState(false);

    const openStateEditor = (product) => {
        const max = Number(product.MaxItemCount) || 0;
        const current = Number(product.Quantity) || 0;
        setEditorSelected(Math.min(current, max));
        setEditorProduct(product);
        setStateEditorOpen(true);
    };

    const closeStateEditor = () => {
        setStateEditorOpen(false);
        setEditorProduct(null);
        setEditorSelected(0);
    };


    const handleSubmit = async (evt) => {
        evt.preventDefault();

        if (isSubmitting) {
            return;
        }
        loader.showLoader(true);
        setIsSubmitting(true);
        try {
            const loadProducts = newMachineProducts.map(p => {
                const old = machineProducts.find(x => String(x.MachineProductId) === String(p.MachineProductId));
                return {
                    MachineFeederNo: p.MachineFeederNo,
                    ProductId: p.ProductId,
                    RecipeId: p.RecipeId ?? null,
                    MachineId: Number(props.machineId),
                    CurrentQuantity: Number(old?.Quantity ?? 0),
                    LoadQuantity: Number(p.income ?? 0),
                };
            });

            const userResponse = await axios.get(`${API_URL}/api/user`);
            const response = await axios.post(`${API_URL}/api/mobile/visit`, {
                userName: userResponse.data.Email,
                userPassword: null,
                machineId: Number(props.machineId),
                loadProducts: JSON.stringify(loadProducts),
                serialNo: machineData?.SerialNo ?? null,
                locationId: machineData?.LocationId ?? null,
                machineTypeId: machineData?.MachineTypeId ?? null,
                maintenanceTypeId: machineData?.MaintenanceTypeId ?? null,
                visitGUID: crypto.randomUUID(),
                lastMachineInventoryId: machineData?.LastMachineInventoryId ?? null,
                isCoinInventory: false,
                isVisitSynchronized: false,
                dataLoadedWithCable: false,
            });

            NotificationManager.success("Wizyta zapisana pomyślnie");
            getMachineProducts();
            setStateConfirmMenu(false);
            setLastVisitId(response.data?.visitId ?? null);
        } catch (error) {
            NotificationManager.error("Wizyta nie została zapisana prawidłowo");
            console.error("Error:", error);
        } finally {
            loader.showLoader(false);
            setIsSubmitting(false);
        }
        loader.showLoader(false);
    };

    const fullDownload = () => {
        setNewMachineProducts((prev) =>
            prev.map((i) => {
                const orig = Array.isArray(machineProducts)
                    ? machineProducts.find((m) => String(m.MachineProductId) === String(i.MachineProductId))
                    : null;
                const origQty = Number(orig?.Quantity ?? 0);
                const origMax = Number(orig?.MaxItemCount ?? 0);
                const income = origMax - origQty;
                const targetQty = origMax;

                if (Number(i.Quantity ?? 0) === targetQty && Number(i.income ?? 0) === income) {
                    return i;
                }

                return { ...i, income: income, Quantity: targetQty };
            })
        );
    }
    const fullUpload = () => {
        setNewMachineProducts((prev) =>
            prev.map((i) => {
                const orig = Array.isArray(machineProducts)
                    ? machineProducts.find((m) => String(m.MachineProductId) === String(i.MachineProductId))
                    : null;
                const origQty = Number(orig?.Quantity ?? 0);
                const income = -origQty;
                const targetQty = 0;

                if (Number(i.Quantity ?? 0) === targetQty && Number(i.income ?? 0) === income) {
                    return i;
                }

                return { ...i, Quantity: targetQty, income: income };
            })
        );
    }

    return (
        <div className="p-3">
            <div className="card">
                <div className="card-header">
                    <p style={{ float: "left" }}>{machineData?.MachineName} ({machineData?.SerialNo})</p>
                    <p style={{ float: "right" }}>Ostatnia wizyta: {machineData?.LastVisit}</p>
                </div>

                <div className="card-body">
                    {newMachineProducts == null || (Array.isArray(newMachineProducts) && newMachineProducts.length === 0) ? (
                        <div className="p-3">Brak produktów</div>
                    ) : (
                        <div className="table-responsive" style={{ overflowX: 'hidden' }}>
                            <div className="d-flex justify-content-between pb-3 pr-3 pl-3">
                                <div >
                                    <i
                                        onClick={fullDownload}
                                        className="fas fa-arrow-circle-up fa-3x"
                                        style={{ color: '#28a745' }}
                                    ></i>
                                </div>
                                <div >
                                    <i
                                        onClick={fullUpload}
                                        className="fas fa-arrow-circle-down fa-3x"
                                        style={{ color: '#dc3545' }}
                                    ></i>
                                </div>
                            </div>

                            <table className="table table-striped" style={{ width: '100%' }}>
                                <tbody>
                                    {Array.isArray(newMachineProducts) && newMachineProducts.map((p, idx) => {
                                        const name = p.Name;
                                        const actualState = Number(p.Quantity ?? 0);
                                        const maxState = Number(p.MaxItemCount);
                                        const key = p.MachineProductId;

                                        const original = Array.isArray(machineProducts)
                                            ? machineProducts.find((orig) => String(orig.MachineProductId) === String(key))
                                            : null;
                                        const originalActual = Number(original?.Quantity ?? 0);
                                        return (
                                            <tr key={key} onClick={() => openStateEditor(p)}>
                                                <td className="py-3 " style={{ maxWidth: '10%', verticalAlign: 'middle' }}>{original.MachineFeederNo}</td>
                                                <td
                                                    className="py-3 "
                                                    title={name}
                                                    style={{ whiteSpace: 'normal', overflow: 'hidden', textOverflow: 'ellipsis', wordBreak: 'break-word', fontSize: '0.85rem' }}
                                                >
                                                    <div className="d-flex align-items-start">
                                                        <div style={{ flex: '1 1 auto' }} className="text-truncate">
                                                            {name} ({new Intl.NumberFormat("pl-PL",
                                                                { style: "currency",
                                                                  currency: "PLN",
                                                                  maximumSignificantDigits: 3 }).format(p.PriceBrutto)})
                                                        </div>
                                                    </div>
                                                    <div className="d-block mt-2">
                                                        <div className="d-flex align-items-center justify-content-center">
                                                            <button
                                                                type="button"
                                                                onClick={() => openStateEditor(p)}
                                                                className={`btn btn-sm ${actualState === maxState ? 'btn-success' :
                                                                    Number(actualState) > 0 ? 'btn-warning' : 'btn-danger'
                                                                    } small`}
                                                                style={{ padding: '0.25rem 0.5rem', lineHeight: '1' }}>
                                                                <div className="d-flex align-items-center justify-content-center">
                                                                    <span style={{ fontSize: '0.9rem' }}>[{originalActual} / {maxState}]
                                                                        {p.income !== undefined && Number(p.income) !== 0 && (
                                                                            `  => [${Number(p.income) + originalActual} / ${maxState}]`
                                                                        )}
                                                                    </span>
                                                                </div>
                                                            </button>

                                                            {(p?.income !== undefined && p?.income !== null && Number(p.income) !== 0) && (
                                                                <span className={`m-1 badge ms-2 ${Number(p.income) > 0 ? 'bg-success' : 'bg-danger'}`} style={{ fontSize: '0.7rem', color: 'white' }}>
                                                                    {Number(p.income) > 0 ? `+${Number(p.income)}` : `${Number(p.income)}`}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>


                                                </td>
                                            </tr>
                                        );
                                    })}
                                    <div
                                        className="card-footer text-center fixed-bottom h-10 "
                                        style={{ backgroundColor: '#cbcbcb' }}
                                    >
                                        <button
                                            onClick={() => setStateConfirmMenu(true)}
                                            disabled={saveButtonDisabled || isSubmitting}
                                            className="btn btn-primary w-20 btn-sm"
                                        >
                                            {isSubmitting ? "Zapisywanie..." : "Zapisz"}
                                        </button>
                                    </div>
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>

            {stateConfirmMenu && (
                <FormSkel headerText={"Zapis wizyty"} handleClose={() => setStateConfirmMenu(false)} >
                    <>
                        <form
                            id="modal-form"
                            onSubmit={
                                handleSubmit
                            }>
                            <div className="p-2">
                                {newMachineProducts && newMachineProducts.length > 0 && (
                                    <ul>
                                        <p>Podsumowanie wizyty</p>
                                        {newMachineProducts.map((product) => (
                                            product.income !== undefined && product.income !== 0 && (
                                                <div key={product.MachineProductId}>
                                                    {product.Name} {product.income > 0 ? `+${product.income}` : product.income}
                                                </div>
                                            )
                                        ))}
                                    </ul>
                                )}
                                <p className="text-bold">Czy na pewno chcesz zapisac wizyte?</p>
                            </div>
                        </form>
                    </>
                </FormSkel>
            )}

            {stateEditorOpen && (
                <FormSkel headerText={"Edytuj stan produktu"} handleClose={closeStateEditor} noFooter={true}>
                    <div className="p-2">
                        <div className="mb-2"></div>
                        <div style={{ overflowY: 'auto' }}>
                            {(() => {
                                const max = Number(editorProduct?.MaxItemCount) || 0;
                                const original = Array.isArray(machineProducts)
                                    ? machineProducts.find((orig) => String(orig.MachineProductId) === String(editorProduct.MachineProductId))
                                    : null;
                                const originalQty = Number(original?.Quantity);

                                return (

                                    Array.from({ length: max + 1 }, (_, i) => i).map((val, index) => (
                                        <div className="form-check" key={val}
                                            onClick={(e) => {
                                                if (sessionStorage.getItem("clientId")?.toLowerCase() === "vit") {
                                                    if (val < originalQty) {
                                                        e.preventDefault();
                                                        return;
                                                    }
                                                }
                                                const selectedVal = Number(val) || 0;
                                                const newValue = selectedVal;
                                                setEditorSelected(selectedVal);
                                                setNewMachineProducts((prev) =>
                                                    prev.map((i) => {
                                                        const iKey = i.MachineProductId;
                                                        const pKey = editorProduct.MachineProductId;
                                                        if (String(iKey) === String(pKey)) {
                                                            const original = Array.isArray(machineProducts)
                                                                ? machineProducts.find((orig) => String((orig.MachineProductId)) === String(pKey))
                                                                : null;
                                                            const originalQty = Number(original?.Quantity);
                                                            return {
                                                                ...i,
                                                                Quantity: newValue,
                                                                income: newValue - originalQty,
                                                            };
                                                        }
                                                        return i;
                                                    })
                                                );

                                                closeStateEditor();
                                            }}
                                        >
                                            <input
                                                className="mr-4"
                                                type="radio"
                                                name="stateRadio"
                                                style={{
                                                    msTransform: "scale(1.5)",
                                                    WebkitTransform: "scale(1.5)",
                                                    transform: "scale(1.5)",
                                                }}
                                                id={`stateRadio_${val}`}
                                                value={val}
                                                disabled={sessionStorage.getItem("clientId")?.toLowerCase() === "vit" && val < originalQty}
                                                checked={Number(editorSelected) === val}
                                                onChange={() => {
                                                    const selectedVal = Number(val) || 0;
                                                    const newValue = selectedVal;
                                                    setNewMachineProducts((prev) =>
                                                        prev.map((i) => {
                                                            const iKey = i.MachineProductId;
                                                            const pKey = editorProduct.MachineProductId;
                                                            if (String(iKey) === String(pKey)) {
                                                                const original = Array.isArray(machineProducts)
                                                                    ? machineProducts.find((orig) => String((orig.MachineProductId)) === String(pKey))
                                                                    : null;
                                                                const originalQty = Number(original?.Quantity);
                                                                return {
                                                                    ...i,
                                                                    Quantity: newValue,
                                                                    income: newValue - originalQty,
                                                                };
                                                            }
                                                            return i;
                                                        })
                                                    );
                                                    closeStateEditor();
                                                }}
                                            />

                                            <label className="form-check-label" htmlFor={`stateRadio_${val}`}>
                                                {val}
                                            </label>
                                            <hr />
                                        </div>
                                    )));

                            })()}
                        </div>
                    </div>
                </FormSkel>
            )}
        </div>
    );
}
